import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";
import api, { money } from "../lib/api";

export default function SearchModal({ open, onClose }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) { setQ(""); setResults([]); }
  }, [open]);

  useEffect(() => {
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/products`, { params: { search: q } });
        setResults(data.slice(0, 6));
      } catch { setResults([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-start justify-center pt-24 px-4" data-testid="search-modal">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-[#141416] gold-border rounded-xl overflow-hidden fade-up">
        <div className="flex items-center gap-3 px-5 py-4 border-b border-[rgba(212,175,55,0.2)]">
          <Search size={20} className="text-[#D4AF37]" />
          <input
            data-testid="search-input"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search perfumes, candles, notes…"
            className="flex-1 bg-transparent outline-none text-[#FAFAF7] placeholder:text-[#FAFAF7]/40 text-lg font-body"
          />
          <button onClick={onClose} data-testid="search-close"><X size={20} className="text-[#FAFAF7]/60 hover:text-[#D4AF37]" /></button>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {results.map((p) => (
            <button
              key={p.id}
              data-testid={`search-result-${p.id}`}
              onClick={() => { onClose(); navigate(`/product/${p.id}`); }}
              className="w-full flex items-center gap-4 px-5 py-3 hover:bg-white/5 text-left transition-colors">
              <img src={p.images?.[0]} alt={p.name} className="w-12 h-14 object-cover rounded" />
              <div className="flex-1">
                <p className="text-[#FAFAF7] font-serif-lux text-lg">{p.name}</p>
                <p className="text-xs text-[#FAFAF7]/50">{p.brand} · {p.subcategory}</p>
              </div>
              <span className="text-[#D4AF37] text-sm">{money(p.price)}</span>
            </button>
          ))}
          {q && results.length === 0 && (
            <p className="px-5 py-8 text-center text-[#FAFAF7]/50 text-sm">No fragrances found for "{q}"</p>
          )}
        </div>
      </div>
    </div>
  );
}
